import React, { useState, useEffect }  from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const OptionIntegerWithOptions = ({}) => {
  return
}

export default OptionIntegerWithOptions;
